import SuperFetch from 'api/SuperFetch';

const getProductStatus = () => {
  return SuperFetch('product-status');
};

export { getProductStatus };
